import React from "react";
import { View, Text, Image } from "react-native";
import Icon from "react-native-vector-icons/Feather";

import { MarkdownText, Background, Card, Button, ScrollView } from "components";
import { useSurveyTheme } from "screens/question/hooks";
import AppInfo from "screens/main/app-info";
import { TokenCheck } from "utils";

import { styles } from "./styles";

const Main = ({ description, startSurvey, survey }) => {
  const { logo, background } = useSurveyTheme();
  return (
    <Background style={styles.background} image={background}>
      <View style={styles.layout}>
        <Card style={styles.card}>
          <View style={styles.logoContainer}>
            <Image
              source={{ uri: logo }}
              resizeMode="contain"
              style={styles.logo}
            />
          </View>
          <View style={styles.descriptionContainer}>
            <ScrollView>
              <Text style={styles.description}>
                <MarkdownText>{description}</MarkdownText>
              </Text>
            </ScrollView>
          </View>
          {survey.loading ? (
            <View style={styles.error}>
              <Text style={styles.errorMessage}>Loading survey</Text>
            </View>
          ) : survey.error ? (
            <View style={styles.error}>
              <Icon name="alert-triangle" size={40} color="red" />
              <Text style={styles.errorMessage}>
                Make sure at least one questionnaire is enabled
              </Text>
            </View>
          ) : (
            <Button
              text={survey.questionnaire.start_button_text || " Start "}
              outline
              onPress={startSurvey}
              color={styles._button?.color}
            />
          )}
          <AppInfo />
        </Card>
      </View>
      <TokenCheck />
    </Background>
  );
};

export default Main;
